export default function LeftArrowIcon(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="16" stroke="white" stroke-width="2" />
      <path d="M20 12L14 18L20 24" stroke="white" stroke-width="2" />
    </svg>
  );
}
